module.exports = __webpack_public_path__ + "static/media/file-contract.160108eb.svg";